module.exports = __webpack_public_path__ + "static/media/Close.61063c94.svg";